<template>
  <LayoutRegistration :heading="heading" :subheading="subheading" :centerSubheading="true">
    <template #main>
      <div class="flex flex-col justify-center">
        <UnraidLoading v-if="loading" :height="64" />
        <UiFormError :text="formError" class="text-center mb-0" />
        <button v-if="!loading" @click="submit" class="button">{{ submitText }}</button>
      </div>
    </template>
    <template #footer>
      <button
        @click="closePopUpFromPopUp()"
        class="text-sm text-grey-lightest hover:text-white focus:text-white underline"
      >{{ $t('regWizPopUp.forms.cancel') }}</button>
    </template>
  </LayoutRegistration>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { UnraidLoading } from '@unraid/shared-components';

import LayoutRegistration from '../../layouts/Registration.vue';
import UiFormError from '../../components/Ui/FormError.vue';

import i18n from '../../i18n';
import { KeyServer } from '../../services';
import { SAFE_JSON_PARSE } from '../../consts';

export default {
  name: 'ViewExtendTrial',
  metaInfo: {
    title: i18n.tc('actions.extend'),
  },
  components: {
    UnraidLoading,
    LayoutRegistration,
    UiFormError,
  },
  data: () => ({
    formError: null,
    loading: false,
  }),
  computed: {
    ...mapState([
      'guid',
    ]),
    formData() {
      return {
        guid: this.guid,
      };
    },
    heading() {
      if (this.formError) this.$t('regWizPopUp.routes.extendTrial.heading.error');
      return this.loading ? this.$t('regWizPopUp.routes.extendTrial.heading.loading') : this.$t('actions.extend');
    },
    subheading() {
      return !this.loading ? this.$t('regWizPopUp.routes.extendTrial.message') : null;
    },
    submitText() {
      return this.loading ? this.$t('regWizPopUp.forms.submitting') : this.$t('regWizPopUp.forms.confirm');
    },
  },
  methods: {
    ...mapActions(['closePopUpFromPopUp']),
    ...mapMutations([
      'SET_APP_ERROR_MESSAGE',
      'SET_TRIAL',
      'SUBMISSION_FROM',
    ]),
    async submit() {
      // reset
      this.formError = null;
      this.loading = true;
      // 🐿 ship it
      return KeyServer.startTrial(this.formData)
        .json()
        .then((data) => {
          this.SUBMISSION_FROM(this.$route.name);
          this.SET_TRIAL(data);
          this.SET_APP_ERROR_MESSAGE(false);
          this.$router.push({ name: 'Success' });
        })
        .catch((error) => {
          // eslint-disable-next-line no-unused-vars
          const [err, data] = SAFE_JSON_PARSE(error.message);
          if (data) {
            this.formError = data.errorMessage ? data.errorMessage : data.error;
          } else {
            this.formError = error;
          }
          this.SET_APP_ERROR_MESSAGE(this.formError);
          this.loading = false;
        });
    },
    preventClose(e) {
      if (this.loading) {
        e.preventDefault();
        // eslint-disable-next-line no-param-reassign
        e.returnValue = '';
        // eslint-disable-next-line no-alert
        alert(this.$t('regWizPopUp.closingPopUpMayLeadToErrors'));
      }
    },
  },
  created() {
    window.addEventListener('beforeunload', this.preventClose);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventClose);
  },
};
</script>
